import { useLangChecker } from '@common/utils/i18n';
import React from 'react';
export const StorePageSection = (props) => {
    const renderTitle = () => (React.createElement(React.Fragment, null, props.introSection ? (React.createElement("h1", { className: "font__title store-page__section-title", ref: useLangChecker }, props.title)) : (React.createElement("h2", { className: "font__title store-page__section-title", ref: useLangChecker }, props.title))));
    return (React.createElement("section", { className: "store-page__section", id: props.id },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row section__content" },
                React.createElement("div", { className: "col-24 col-lg-5 col-xxl-4 first-col" }, renderTitle()),
                React.createElement("div", { className: "col-24 col-lg-14 col-xxl-12 offset-xxl-2 last-col" }, props.children)))));
};
export const StorePageInnerSection = (props) => {
    const TitleTag = `${props.titleTag || (props.hasIndexes ? 'p' : 'h3')}`;
    const renderTitle = () => (React.createElement(React.Fragment, null,
        React.createElement(TitleTag, { className: "font__title store-page__inner-section-title" }, props.title)));
    return (React.createElement("section", { className: "store-page__inner-section" },
        React.createElement("div", { className: "row section__content" },
            React.createElement("div", { className: "col-24 col-lg-4 first-col" }, renderTitle()),
            React.createElement("div", { className: "col-24 col-lg-20  last-col" }, props.children))));
};
